// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { carouselStyles } from "@synd/Overrides/Components/Carousel";
import { color, mergeWithCss } from "@synd/XDL/Utilities";
import { css } from "styled-components";

carouselStyles.carouselSlidesContainer = {
    css: css`
        display: flex;
        ${({ isVertical }: any) =>
            isVertical &&
            css`
                flex-direction: column;
                height: 100%;
                max-height: 500px;
            `}
    `,
};

carouselStyles.carouselSlideInner = {
    css: css`
        width: 100%;
        height: 100%;
        position: relative;
        padding: ${({ isVertical }: any) => (isVertical ? "8px 0" : "8px 20px")};
        display: flex;
        justify-content: ${({ isVertical }: any) => (isVertical ? "start" : "center")};
    `,
};

carouselStyles.verticalPrevArrowGridItem =
    carouselStyles.verticalNextArrowGridItem =
    carouselStyles.verticalCarouselGridItem =
        {
            width: 12,
        };
carouselStyles.carouselGridItem = {
    ...mergeWithCss(carouselStyles.carouselGridItem, {
        css: css`
            flex-direction: column;
        `,
    }),
};
carouselStyles.nextArrowButton = carouselStyles.prevArrowButton = {
    variant: "link" as any,
    color: "common.ui7",
    css: css`
        ${IconWrapper} {
            &,
            svg {
                width: 10px;
                height: 18px;
            }
        }
        &&&&:not(:disabled) {
            ${IconWrapper} {
                color: ${color("common.ui7")};
            }
            & :hover {
                ${IconWrapper} {
                    color: ${color("common.ui9")};
                }
            }
        }
    `,
};

carouselStyles.dotsWrapper = {
    css: css`
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        margin: 12px 0;
        gap: 2px;
        .dot {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            border: 1px solid ${color("common.ui11")};
            cursor: pointer;
            &:hover {
                background: ${color("common.ui9")};
            }
            &.selected {
                background: ${color("common.ui11")};
            }
        }
    `,
};
